import { apiClient } from '~/api/client';

type Params = {
  key: string;
};

export const masquerade = async (params: Params) =>
  apiClient.post(`/users/masquerade?masquerade=${params.key}`);

export const masqueradeBack = async () => apiClient.post('/users/masquerade_back');
